import React from "react";
import { Checkbox, Typography } from "@mui/material";
import { Control, Controller, UseFormSetValue } from "react-hook-form";
import TimePicker from "components/TimePcker";
import timerIcon from "assets/common/history_toggle_off.svg";
import * as Styled from "../styles";
import { MassEditWorkingHoursFormData } from "../types";
import { TIME_VALIDATION_RULES } from "../constants";

interface HolidayRowProps {
  control: Control<MassEditWorkingHoursFormData>;
  setValue: UseFormSetValue<MassEditWorkingHoursFormData>;
  isEnabled: boolean;
  isOpen: boolean;
  onEnabledChange: (enabled: boolean) => void;
  onIsOpenChange: (isOpen: boolean) => void;
}

const HolidayRow: React.FC<HolidayRowProps> = ({
  control,
  setValue,
  isEnabled,
  isOpen,
  onEnabledChange,
  onIsOpenChange,
}) => {
  return (
    <Styled.HolidayRowContainer>
      <Controller
        name="holiday.enabled"
        control={control}
        render={({ field }) => (
          <Styled.HolidayRowPrefixContent>
            <Checkbox
              {...field}
              checked={field.value || false}
              size="small"
              onChange={(e) => {
                field.onChange(e.target.checked);
                onEnabledChange(e.target.checked);
              }}
            />
            <Typography variant="body2">
              Estabelecer horário padrão para feriados
            </Typography>
          </Styled.HolidayRowPrefixContent>
        )}
      />
      <Styled.HolidayPickerRowContent isActive={isOpen}>
        <Typography
          variant="body2"
          width="100px"
          color="primary.main"
          fontWeight="bold"
        >
          Feriado
        </Typography>
        {isOpen ? (
          <>
            <TimePicker
              control={control}
              name="holiday.open"
              label="Abre"
              setValue={setValue}
              defaultValue="00:00"
              disabled={!isEnabled || !isOpen}
              rules={{
                minLength: 5,
                ...TIME_VALIDATION_RULES,
                required:
                  isEnabled && isOpen
                    ? "Horário de abertura é obrigatório"
                    : false,
              }}
            />
            <Typography variant="body2">até</Typography>
            <TimePicker
              control={control}
              name="holiday.close"
              label="Fecha"
              setValue={setValue}
              defaultValue="23:59"
              disabled={!isEnabled || !isOpen}
              rules={{
                minLength: 5,
                ...TIME_VALIDATION_RULES,
                required:
                  isEnabled && isOpen
                    ? "Horário de fechamento é obrigatório"
                    : false,
              }}
            />
          </>
        ) : (
          <Styled.TimerIconContainer>
            <Styled.TimerIcon src={timerIcon} alt="Horário não definido" />
          </Styled.TimerIconContainer>
        )}
        <Styled.ContainerButton isActive={isOpen}>
          <Controller
            name="holiday.isOpen"
            control={control}
            render={({ field }) => (
              <>
                <Styled.CustomSwitch
                  {...field}
                  checked={field.value || false}
                  size="small"
                  color="success"
                  disabled={!isEnabled}
                  onChange={(e) => {
                    field.onChange(e.target.checked);
                    onIsOpenChange(e.target.checked);
                  }}
                />
                <Typography>{field.value ? "Aberto" : "Fechado"}</Typography>
              </>
            )}
          />
        </Styled.ContainerButton>
      </Styled.HolidayPickerRowContent>
    </Styled.HolidayRowContainer>
  );
};

export default React.memo(HolidayRow);
